import React from "react";
import TitleSection from "../../molecules/title-section";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Link } from "gatsby";

// Styles //
import "./encontrarTalentoAccess.scss";

const EncontrarTalentoAccess = (props: ReferenciaContenido) => {
    const { 
        tituloGeneral, 
        descripcion,
        descripcionFija,
        tituloBoton,
        redireccionBoton,
        listaImagenes
    } = props;

    return (
       
        <div className="o-encontrar-talento-access">
            <div className="o-encontrar-talento-access__container">
                <div className="o-encontrar-talento-access__container__title">
                    <TitleSection title={tituloGeneral} />
                </div>
                <div className="o-encontrar-talento-access__container__first-step left-box">
                    <div className="o-encontrar-talento-access__container__first-step__image">
                        <img
                            src={listaImagenes[0].file.url}
                            alt="Icono primer paso"
                        />
                    </div>
                    <div className="o-encontrar-talento-access__container__first-step__description">
                        <p>{documentToReactComponents(descripcion.json.content[0].content[0])}</p>
                        <Link
                            className="gtm_encontrar_talento_pasos_conectar_talento"
                            to={redireccionBoton}>
                            <button>{tituloBoton}</button>
                        </Link>
                    </div>
                </div>
                <div className="o-encontrar-talento-access__container__second-step right-box">
                    <div className="o-encontrar-talento-access__container__second-step__image">
                        <img
                            src={listaImagenes[1].file.url}
                            alt="Icono segundo paso"
                        />
                    </div>
                    <div className="o-encontrar-talento-access__container__second-step__description">
                        <p>{documentToReactComponents(descripcionFija.content[0].content[0])}</p>
                    </div>
                </div>
            </div> 
        </div>
    );
};

export default EncontrarTalentoAccess;
